import Cookies from 'js-cookie/src/js.cookie'

/**
 * Cookies Pop-Up
 */
window.showCookiePopUp = function () {
    if (Cookies.get("allowCookies") === undefined || atob(Cookies.get("allowCookies")) != '1') {
        $(".toast").toast("show");
        $("#cookiePopUp").css("display", "block");
    } else {
        $("#cookiePopUp").css("display", "none");
    }
};

window.hideCookiePopUp = function () {
    $(".toast").toast("hide");
    $("#cookiePopUp").css("display", "none");
    Cookies.set("allowCookies", btoa('1'), { expires: 30 });
};

$(function () {
    // Mostramos la alerta de cookies
    showCookiePopUp();
});
